<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">About Raisoni Group</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="#">About Raisoni Group</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="about-institute ptb--100">
  <div class="container">
    <div class="row">
      <div class="col">
        <blockquote class="blockquote-div">
          <p>A Legacy of Excellence in Education
          </p>
          <!-- <h6>- Anthony J. D’Angelo</h6> -->
        </blockquote>

        <p>Raisoni Education, a leading educational network in Central India, boasts a rich history of nurturing future
          leaders across various disciplines. Established in 1998 with the foundation of G H Raisoni College of
          Engineering in Nagpur, Raisoni Education has grown steadily, encompassing 19 institutes and 4 universities
          which are spread across six cities - Nagpur, Jalgaon, Pune, Amravati, Pandhurna and Bhandara.</p>
        <!-- <p>Keeping the same in mind, we the Raisoni Group have developed learning platforms for the students and learners to aid in establishing new milestones, successful ventures and flourishing lives.</p> -->
        <p>We have had a proven record of producing the most educated professionals. And, it is this reason the journey
          which started with the establishment of a single institute in the year 1998, has never ceased to grow. Our
          very first educational institute was G H Raisoni College of Engineering in Nagpur. </p>
        <p>With over four decades of combined history, the Group has diversified in the fields of Manufacturing,
          Distribution, Marketing, Construction and Healthcare. Presently, the Group’s concentration has been more of
          the fields of Education which paves the way for success stories and builds a better tomorrow. An innovative
          approach at every step towards success sets the RGI apart. We chose to provide practically oriented education
          combined with a strong academic focus, developed specifically to meet industry needs.</p>
        <p>Since the start of the journey, our motto has been ‘the vision beyond’.</p>
        <p>And, it is for the students to comprehend the motto in accordance with their perception. They can associate
          it with a vision beyond sight in order to accomplish the goals which are far away from their sight. Or, as a
          vision beyond dreams, enabling them to work with diligence, achieving the limitless sky! Or, even a vision
          beyond excellence, nurturing in them the power of knowledge. So, come over and start the journey which
          motivates you at every step, which gives you wings to soar new heights.</p>
        <h4 class="yellow-color mt-3 fw-bold">The Attributes which we are Proud of :</h4>
        <ul class="list-before">
          <li><strong>Quality Education</strong> - With well-updated courses for our students, we have made sure to
            establish a benchmark for ourselves. The finest of the courses are preparing students for successful careers
            in the real world. We make sure to keep our courses up-to-date, reflecting the latest trends owing to our
            close association with the industry.</li>
          <li><strong>Plethora of Courses</strong> - A plethora of courses are executed at our K-12, undergraduate and
            post graduate programs. The professional courses such as Management, Engineering, Law, MCA, Polytechnic,
            Commerce and Science are the best in the industry with us.</li>
          <li><strong>State-of-the-art Infrastructure</strong> - Since we have a variety of streams being taught in our
            institutes, we make sure to follow the finest standards with excellence. Each and every course we have gives
            the students preeminence in the learning procedure, the premium tools and the state-of-the-art
            infrastructure.</li>
          <li><strong>Well Structured Placement Cell</strong> - With a well-structured placement cell and comprehensive
            assistance availing the finest positions in the real world becomes easy.</li>
          <li><strong>Campus</strong> - Our campuses have been developed specifically to provide students with a
            challenging and rewarding experience in an optimal learning environment. It includes extensive academic and
            social support services to assist our students to succeed.</li>
          <li><strong>Career Focused Curriculum</strong> - Our curriculum is so made that it focuses on career-driven
            strategies. It involves diverse practical and theoretical approach to aid the students to fabricate a sound
            career.</li>
          <li><strong>Dedicated Team</strong> - The most diligent, knowledgeable and organized team of educators with
            1300 members is a part of us. Mingle it with the best-supporting staff of 1400 members and there is no
            looking back for us.</li>
          <li><strong>The Guiding Light</strong> - 24 institutes, 25,000 students and 800 classrooms has been possible
            with the guiding light and motivation of the chairman of the group Mr Sunil Raisoni.</li>
        </ul>
        <blockquote class="blockquote-div">
          <p>“Think Education, Think Raisoni” is not the motto of our team, it is the most heard sentence of Central
            India.</p>
        </blockquote>
      </div>
    </div>
  </div>
</section>
